
ScrollReveal().reveal('.animateRight', {
  duration: 1200,
  distance: '480px',
  origin: 'right',
  viewFactor: '0.2'
});

ScrollReveal().reveal('.animateLeft', {
  duration: 1500,
  distance: '100px',
  origin: 'left',
  viewFactor: '0.2',
});

ScrollReveal().reveal('.animateBottom', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: '0.2',
});


ScrollReveal().reveal('.animateBottomText', {
  duration: 1200,
  distance: '100px',
  origin: 'bottom',
  viewFactor: '1',
});

ScrollReveal().reveal('.animateslow', {
  duration: '800',
  viewFactor: '0.2',
  reset: 'true'
});